import React, { FC } from "react";
import { INavItem } from "../../components/layouts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useNavigate from "../../hooks/useNavigate";

import "./SettingsCard.scss";

interface ISettingsCardProps {
    navItem: INavItem;
}

const SettingsCard: FC<ISettingsCardProps> = ({ navItem }) => {
    const navigate = useNavigate();

    return (
        <div className="settings-card" onClick={() => navigate(navItem.url)}>
            <div className="settings-card-header">
                <FontAwesomeIcon icon={navItem.icon} />
                {navItem.title}
            </div>
            <div className="settings-card-body">
                <p>{navItem.description}</p>
            </div>
        </div>
    );
};

export default SettingsCard;
